import Chat from "@/pages/redecredenciada/chatbot/chat.vue";
import NetworkSearch from "@/pages/network-search/index.vue";

const routes: Route[] = [
  {
    path: "/redecredenciada-prototipo",
    redirect: "/redecredenciada-prototipo/chat",
    component: NetworkSearch,
    children: [
      {
        path: "chat",
        name: "redecredenciada-prototipo.chat",
        component: Chat,
        meta: {
          basePath: "/redecredenciada",
          registerAccess: {
            servico: "Chatbot da Busca de Rede",
            funcionalidade: "App Omint - Acesso ao Chatbot da busca de rede"
          },
          validPath: ["/redecredenciada", "/redecredenciada-home"]
        }
      }
    ]
  }
];
export default routes;
